module.exports = __webpack_public_path__ + "img/1572202238.4003ee46.jpg";